<template>
    <b-modal
        v-if="entity"
        v-model="modal.state"
        size="sm"
        dialog-class="delete-saved-search-modal"
        header-class="px-3 pt-3 pb-0"
        body-class="px-3 py-0"
        footer-class="p-3"
        @hidden="handleHidden"
    >
        <template
            class="pb-0"
            v-slot:modal-header
        >
            <i class="fal fa-exclamation-circle fa-2x text-danger warning-icon" />
        </template>

        <template v-slot:default>
            <div class="text-center mt-1">
                <h2 class="modal-title mb-2">
                    Delete Saved Search
                </h2>
                <div>
                    Are you sure you want to delete
                    <span class="font-weight-bold text-break">{{ savedSearchName }}</span> ?
                    <br>
                    This action cannot be undone.
                </div>
            </div>
        </template>

        <template v-slot:modal-footer="{ cancel }">
            <b-button-toolbar
                class="w-100"
                justify
            >
                <b-button
                    @click="deleteSavedSearch"
                    block
                    class="modal-btn"
                    size="lg"
                    variant="danger"
                >
                    Delete
                </b-button>

                <b-button
                    @click="cancel"
                    block
                    class="text-dark border-0 modal-btn"
                    size="lg"
                    variant="tertiary"
                >
                    Cancel
                </b-button>
            </b-button-toolbar>
        </template>
    </b-modal>
</template>

<script>
    import './DeleteSavedSearchModal.scss';
    import ShowNotificationMixin from '@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin';
    import { PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED } from "../GroupPropertySavedSearchesCard/PropertySavedSearchesCard";
    import {
        PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE
    } from "../GroupPropertySavedSearchesCard/PropertySavedSearchesCardHeader/PropertySavedSearchesCardHeader";
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";

    export const DELETE_SAVED_SEARCH_MODAL_DISPLAY = 'DeleteSavedSearchModal:display';

    export default {
        name: "DeleteSavedSearchModal",

        mixins: [
            ShowNotificationMixin,
        ],

        data() {
            return {
                entity: null,
                modal: {
                    state: false,
                },
            };
        },

        computed: {
            savedSearchName() {
                if(!this.entity) {
                    return '';
                }
                return this.entity.name;
            },
        },

        async beforeMount() {
            this.$bus.$on(DELETE_SAVED_SEARCH_MODAL_DISPLAY, ({entity}) => {
                if (!(entity instanceof PropertySearchFilterAppResource)) {
                    throw new Error('Invalid payload, entity should be an instance of PropertySearchFilterAppResource');
                }

                this.init(entity);
            });
        },

        methods: {
            async deleteSavedSearch() {
                try {
                    await this.entity.delete();
                    this.$bus.$emit(PROPERTY_SAVED_SEARCHES_CARD_HEADER_DELETE);
                    this.showNotification({
                        message: 'Saved search deleted!',
                        type: 'success',
                        toaster: 'layoutToaster',
                    });
                } catch (e) {
                    this.showNotification({
                        message: 'Something went wrong. Please try again later',
                        type: 'error'
                    });
                    console.error(e);
                } finally {
                    this.handleHidden();
                    this.$bus.$emit(PROPERTY_SAVED_SEARCH_INSTANCE_MOUNTED);
                }
            },

            async init(entity) {
                let tempEntity = new PropertySearchFilterAppResource({uuid: entity.uuid});
                try {
                    await tempEntity.fetch();
                } catch (e) {
                    this.showNotification({
                        message: 'Can not load saved search data. Please try again later.',
                        type: 'error',
                        toaster: 'layoutToaster',
                    });
                }
                this.entity = tempEntity;
                this.modal.state = true;
            },

            handleHidden() {
                this.entity = null;
            },
        },
    };
</script>

